module.exports = __webpack_public_path__ + "img/k6.5984058f.png";